export default __webpack_public_path__ + "static/media/laptop_ass-04.a296b126.svg";